'use client';
import React, { createContext, useState } from 'react';

interface AlertsContextProps {
  alerts: AlertNotification[];
  setAlerts: React.Dispatch<React.SetStateAction<AlertNotification[]>>;
}

export const AlertsContext = createContext<AlertsContextProps>({
  alerts: [],
  setAlerts: () => null
});

export const AlertsProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [alerts, setAlerts] = useState<AlertNotification[]>([]);

  return (
    <AlertsContext.Provider value={{ alerts, setAlerts }}>
      {children}
    </AlertsContext.Provider>
  );
};

export const useAlerts = () => React.useContext(AlertsContext);
